__turbopack_context__.v({
  "wrapper": "XPHkzG_wrapper",
});
